import { render } from "./ExcelButton.vue?vue&type=template&id=0d27f5b7&scoped=true&ts=true"
import script from "./ExcelButton.vue?vue&type=script&lang=ts"
export * from "./ExcelButton.vue?vue&type=script&lang=ts"

import "./ExcelButton.vue?vue&type=style&index=0&id=0d27f5b7&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d27f5b7"]])

export default __exports__